// useApiRequests.ts
import React from "react";
import { useState } from "react";
import { useNotification } from "./useNotification";
import { IUser } from "../interfaces/IUser";
import { IStatusUploadHomologacao } from "../interfaces/IUploadHomologacao";

import { useApi } from "../Context/ApiContext";
import { useCookies } from "react-cookie";
import { IMember } from "../interfaces/IMember";
import { useLocation } from "react-router-dom";
import { IFrontTask } from "../interfaces/ITask";
import { IBoard } from "../interfaces/IBoard";
import { IMemberActions } from "../interfaces/IMember";
import axios from "axios";
// Removed import for getCookieOptions to avoid compilation issues
interface ApiResponse {
    success: boolean;
    msg?: string;
    data?: any;
}

interface ApiRequests {
    loading: boolean;

    //Dashboard
    getDashboardData: (period: string) => Promise<ApiResponse>;
    getDashboardRealGraphData: () => Promise<ApiResponse>;
    getAllBoards: () => Promise<ApiResponse>;

    //Members
    getBoardMembers: () => Promise<ApiResponse>;
    updateMember: (member?: IMember) => Promise<ApiResponse>;
    createMember: (member?: IMember) => Promise<ApiResponse>;
    currentMemberCanScreeaning: () => Promise<ApiResponse>;
    getCurrentMember: () => Promise<ApiResponse>;
    deleteMembers: (id: string) => Promise<ApiResponse>;

    //Login
    signUp: (user: IUser) => Promise<ApiResponse>;
    signIn: (user: IUser) => Promise<ApiResponse>;
    authWithCode: (code: string) => Promise<ApiResponse>;

    //Settings
    getApiTokenLink: () => Promise<ApiResponse>;
    getDashboardLists: (id: string) => Promise<ApiResponse>;
    getDashboardBadges: (id: string) => Promise<ApiResponse>;
    getSettings: () => Promise<ApiResponse>;
    saveSettings: (settings: any) => Promise<ApiResponse>;

    getMetricsMembers: () => Promise<ApiResponse>;
    getMemberById: (id?: string) => Promise<ApiResponse>;
    getMetrics: (period: string, customPeriod: any, onlyUser: string) => Promise<ApiResponse>;
    getScreeningMetrics: (period: string, customPeriod: any) => Promise<ApiResponse>;
    getMemberCode: (id: string, type: string) => Promise<ApiResponse>;

    //Global
    getMenuData: () => Promise<ApiResponse>;
    getUserRoleInBoard: (settings: any) => Promise<ApiResponse>;
    getMyNotifications: () => Promise<ApiResponse>;
    viewNotification: (id: string) => Promise<ApiResponse>;
    isPageScreening: (route: string) => Promise<ApiResponse>;
    clearNotifications: () => Promise<ApiResponse>;

    getReportData: (memberId: string) => Promise<ApiResponse>;
    getBoardTasks: (itensPerPage: number, currentPage: number, filters: any) => Promise<ApiResponse>;
    getBoardTasksForTester: (currentURL: string) => Promise<ApiResponse>;
    getFilters: () => Promise<ApiResponse>;
    getMembers: () => Promise<ApiResponse>; //A diferença dessa para o getBoardMembers é que essa é mais rápida, pois só busca do trello
    getFilteredData: (filters: any, id: string) => Promise<ApiResponse>;
    createTask: (task: IFrontTask) => Promise<ApiResponse>;
    updateTask: (task: IFrontTask) => Promise<ApiResponse>;
    updateTaskVersion: (version: string, id: string) => Promise<ApiResponse>;
    getTaskByTrelloId: (id: string) => Promise<ApiResponse>;
    getTaskEvidency: (id: string) => Promise<ApiResponse>;
    deleteTaskByTrelloId: (id: string) => Promise<ApiResponse>;
    moveTaskToList: (name: string, id: string) => Promise<ApiResponse>;
    moveTaskToNextStatus: (id: string) => Promise<ApiResponse>;

    getTaskComments: (id: string) => Promise<ApiResponse>;
    getTaskActions: (id: string) => Promise<ApiResponse>;
    getCurrentUserRole: () => Promise<ApiResponse>;

    //Tasks
    addNewComment: (id: string, comment: string, code: string) => Promise<ApiResponse>;
    avoidTask: (id: string, comment: string) => Promise<ApiResponse>;
    getTaskDevInfo: (id: string) => Promise<ApiResponse>;
    taskInExternalFactor: (taskId: string, emailMessage: string) => Promise<ApiResponse>
    startTaskDevelopment: (id: string) => Promise<ApiResponse>;
    stopTaskDevelopment: (id: string) => Promise<ApiResponse>;
    joinTheTask: (id: string) => Promise<ApiResponse>;
    leaveTheTask: (id: string) => Promise<ApiResponse>;
    newVote: (taskEmail: any) => Promise<ApiResponse>;
    editComment: (
        id: string,
        commentId: string,
        comment: string
    ) => Promise<ApiResponse>;
    deleteComment: (id: string, commentId: string) => Promise<ApiResponse>;
    getTaskVersions: (type: string) => Promise<ApiResponse>;
    aprovePartnerTask: (id: string, priority: string) => Promise<ApiResponse>;
    aprovePartnerCustomization: (id: string, priority: string) => Promise<ApiResponse>;

    //Tools
    getAllTools: () => Promise<ApiResponse>;
    getToolById: (id: string) => Promise<ApiResponse>;
    createNewTool: (tool: any) => Promise<ApiResponse>;
    updateTool: (tool: any) => Promise<ApiResponse>;
    deleteTool: (id: string) => Promise<ApiResponse>;

    //Boards
    getBoards: () => Promise<ApiResponse>;
    getBoardById: (id: string) => Promise<ApiResponse>;
    createNewBoard: (board: IBoard) => Promise<ApiResponse>;
    updateBoard: (board: IBoard) => Promise<ApiResponse>;
    deleteBoard: (id: string) => Promise<ApiResponse>;

    //Pocketnaro
    updateIdsTaskMembers: () => Promise<ApiResponse>;
    updateMemberToTrelloId: () => Promise<ApiResponse>;
    updateListToStatus: () => Promise<ApiResponse>;
    testPartnerEmail: () => Promise<ApiResponse>;
    getInertiaNotifications: () => Promise<ApiResponse>;
    updateAllVersions: () => Promise<ApiResponse>;


    //Status
    createStatus: (status: any) => Promise<ApiResponse>;
    updateStatus: (status: any) => Promise<ApiResponse>;
    detailStatus: (string: string) => Promise<ApiResponse>;
    deleteStatus: (id: string) => Promise<ApiResponse>;
    getAllStatus: () => Promise<ApiResponse>;

    // UploadHomologacao
    uploadHomologacao: (data: IStatusUploadHomologacao) => Promise<ApiResponse>;
    getStatusUploadHomologacao: (id: string) => Promise<ApiResponse>;

    // WhiteLabel
    getWhiteLabels: (emails: string[]) => Promise<ApiResponse>;

    //Profile
    getDeadlineTasks: () => Promise<ApiResponse>;
    getComplexityGraph: () => Promise<ApiResponse>;
    getToolsGraph: () => Promise<ApiResponse>;

    //Actions
    getAllMemberActions: () => Promise<ApiResponse>;
    updateAllMemberActions: (actions: IMemberActions[]) => Promise<ApiResponse>;
    calculateMemberActionsChange: (actions: IMemberActions, type: string) => Promise<ApiResponse>;
    getMemberActionByStatus: (id: string) => Promise<ApiResponse>;
    updateMembersActions: (actions: IMemberActions) => Promise<ApiResponse>;

    //Codes
    getCode: (email: string, taskId: string) => Promise<ApiResponse>;

    //Public Tasks (sem autenticação)
    searchPublicApprovedTasks: (filters: any) => Promise<ApiResponse>;
    getPublicTaskById: (taskId: string) => Promise<ApiResponse>;

}

const useApiRequests = (): ApiRequests => {
    const { notify } = useNotification();
    const { handleUnauthorized, setIsUnauthorized, isUnauthorized } = useApi();
    const location = useLocation();

    const [cookies, setCookie, removeCookie, getCookie] = useCookies(["token"]);
    const [loading, setLoading] = useState(false);

    // Configurações de cookie para persistência
    const cookieOptions = {
        path: '/',
        maxAge: 60 * 60 * 24 * 30, // 30 dias
        sameSite: 'lax' as const,
        secure: false // Mude para true em produção com HTTPS
    };

    const handleRequest = async (
        url: string,
        method: string = "GET",
        body: any = null,
        showNotificationError: boolean = true
    ): Promise<ApiResponse> => {
        try {
            setLoading(true);
            const headers = {
                "Content-Type": "application/json",
                Authorization: cookies.token ? `Bearer ${cookies.token}` : "", // Adiciona o token no header, se existir
            };
            const response = await fetch(url, {
                method,
                headers,
                body: body ? JSON.stringify(body) : null,
            });
            if (response.ok) {
                setIsUnauthorized(false);
                const data = await response.json();
                return data;
            } else if (response.status === 400) {
                // console.log(response);
            } else if (response.status === 401) {
                // //console.log('Usuário não autorizado. Redirecionando para /signin');
                removeCookie("token");

                var sessionCode = sessionStorage.getItem("code");
                if (sessionCode != undefined && sessionCode != null) {
                    await authWithCode(sessionCode);
                } else {
                    handleUnauthorized();
                }  //console.log(location.pathname)

                return { success: false, msg: "Usuário não autorizado", data: "" };
            }
        } catch (error) {

            if(showNotificationError)
                notify(`Erro ao processar a solicitação: ${error}`, { type: "error" });

            throw error;
        } finally {
            setLoading(false);
        }

        return { success: false, msg: "" };
    };

    const handleRequestFile = async (url: string): Promise<Blob | null> => {
        try {
            const response = await axios.get(url, {
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (response.status === 200) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error fetching file:', error);
            return null;
        }
    };
    

    const signUp = async (user: IUser): Promise<ApiResponse> => {
        const url = `Login/sign-up`;
        const response = await handleRequest(url, "POST", user);
        // //console.log("res", response)
        // Verifica se a resposta é bem-sucedida e contém um token
        if (response.success && response.data && response.data.token) {
            // Armazena o token em cookies com configurações de persistência
            setCookie("token", response.data.token, cookieOptions);
            window.location.href = "/";
        } else {
            notify(`Erro ao processar a solicitação: ${response.msg}`, {
                type: "error",
            });
        }

        return response;
    };

    const signIn = async (user: IUser): Promise<ApiResponse> => {
        const url = `Login/sign-in`;
        const response = await handleRequest(url, "POST", user);
        // //console.log("res", response)
        // Verifica se a resposta é bem-sucedida e contém um token
        if (response.success && response.data && response.data.token) {
            // Armazena o token em cookies com configurações de persistência
            setCookie("token", response.data.token, cookieOptions);
            window.location.href = "/";
        } else {
            notify(`Erro ao processar a solicitação: ${response.msg}`, {
                type: "error",
            });
        }

        return response;
    };

    //SETTINGS
    const getDashboardLists = async (id: string): Promise<ApiResponse> => {
        const url = `Settings/get-dashboard-lists/${id}`;
        return handleRequest(url);
    };

    const getDashboardBadges = async (id: string): Promise<ApiResponse> => {
        const url = `Settings/get-dashboard-badges/${id}`;
        return handleRequest(url);
    };

    const saveSettings = async (settings: any): Promise<ApiResponse> => {
        const url = "Settings/save";
        return handleRequest(url, "POST", settings);
    };

    const getSettings = async (): Promise<ApiResponse> => {
        const url = `Settings/get-settings`;
        return handleRequest(url);
    };

    const getApiTokenLink = async (): Promise<ApiResponse> => {
        const url = "Settings/get-api-auth-route";
        return handleRequest(url);
    };

    //DASHBOARD
    const getDashboardData = async (period: string): Promise<ApiResponse> => {
        const url = `Dashboard/get-board-data/${period}`;
        return handleRequest(url);
    };

    // NOVO: Dashboard dados reais
    const getDashboardRealGraphData = async (): Promise<ApiResponse> => {
        const url = `Dashboard/real-graph-data`;
        return handleRequest(url);
    };

    const getAllBoards = async (): Promise<ApiResponse> => {
        const url = "Dashboard/get-my-boards";
        return handleRequest(url);
    };

    //METRICS
    const getReportData = async (memberId: string): Promise<ApiResponse> => {
        const url = `Metrics/get-report-data/${memberId}`;
        return handleRequest(url);
    };

    const getMetrics = async (
        period: string,
        customPeriod: any,
        onlyUser: string
    ): Promise<ApiResponse> => {
        const url = `Metrics/get-data/${period}/${onlyUser}`;
        return handleRequest(url, "POST", customPeriod);
    };

    const getScreeningMetrics = async (
        period: string,
        customPeriod: any,
    ): Promise<ApiResponse> => {
        const url = `Metrics/get-screening-data/${period}`;
        return handleRequest(url, "POST", customPeriod);
    };

    const getMetricsMembers = async (): Promise<ApiResponse> => {
        const url = "Metrics/members";
        return handleRequest(url);
    };

    //REGISTER
    const getBoardMembers = async (): Promise<ApiResponse> => {
        const url = "Register/get-board-members";
        return handleRequest(url);
    };

    const deleteMembers = async (id: string): Promise<ApiResponse> => {
        const url = `Register/delete-member/${id}`;
        return handleRequest(url);
    }

    const updateMember = async (member?: IMember): Promise<ApiResponse> => {
        const url = "Register/update-member";
        return handleRequest(url, "POST", member);
    };

    const createMember = async (member?: IMember): Promise<ApiResponse> => {
        const url = "Register/create-member";
        return handleRequest(url, "POST", member);
    };

    const getMemberById = async (id?: string): Promise<ApiResponse> => {
        const url = `Register/get-member/${id}`;
        return handleRequest(url);
    };

    const getMemberCode = async (
        id: string,
        type: string
    ): Promise<ApiResponse> => {
        const url = `Register/get-member-code/${id}/${type}`;
        return handleRequest(url);
    };

    const currentMemberCanScreeaning = async (): Promise<ApiResponse> => {
        const url = `Register/current-member-can-screening`;
        return handleRequest(url);
    };
    const getCurrentMember = async (): Promise<ApiResponse> => {
        const url = `Register/get-current-member`;
        return handleRequest(url);
    };
    //GLOBAL
    const getMenuData = async (): Promise<ApiResponse> => {
        const url = "Global/get-menu";
        return handleRequest(url);
    };

    const getUserRoleInBoard = async (settings: any): Promise<ApiResponse> => {
        const url = `Global/get-user-role-in-board`;
        return handleRequest(url, "POST", settings);
    };

    const getFilters = async (): Promise<ApiResponse> => {
        const url = `Global/get-filters`;
        return handleRequest(url);
    };

    const getMembers = async (): Promise<ApiResponse> => {
        const url = `Global/get-members`;
        return handleRequest(url);
    };

    const getCurrentUserRole = async (): Promise<ApiResponse> => {
        const url = `Global/get-current-user-role`;
        return handleRequest(url);
    };

    const getMyNotifications = async (): Promise<ApiResponse> => {
        const url = `Global/get-my-notifications`;        
        try {
            return handleRequest(url, "GET",null, false);
        }
        catch(error) { 
            return {success: true, msg: "", data: {new:[], old:[]}}
        }
    };

    const clearNotifications = async (): Promise<ApiResponse> => {
        const url = `Global/clear-notifications`;
        return handleRequest(url, 'PUT');
    };

    const viewNotification = async (id: string): Promise<ApiResponse> => {
        const url = `Global/view-notification/${id}`;
        return handleRequest(url);
    };

    const isPageScreening = async (route: string): Promise<ApiResponse> => {
        const url = `Global/is-page-screening/${route}`;
        return handleRequest(url);
    };

    //LOGIN
    const authWithCode = async (code: string): Promise<ApiResponse> => {
        const url = `Login/authenticate-code?code=${code}`;
        const response = await handleRequest(url);
        if (response.success && response.data && response.data.token) {
            // Armazena o token em cookies com configurações de persistência
            setCookie("token", response.data.token, cookieOptions);
            window.location.href = "/";
        } else {
            notify(`Erro ao processar a solicitação: ${response.msg}`, {
                type: "error",
            });
        }
        return response;
    };

    //TASKS
    const getBoardTasks = async (itensPerPage: number, currentPage: number, filters: any): Promise<ApiResponse> => {
        const url = `Tasks/get-board-tasks?currentPage=${currentPage}&itensPerPage=${itensPerPage}`;
        return handleRequest(url, 'POST', filters);
    };

    const getBoardTasksForTester = async (
        currentURL: string
    ): Promise<ApiResponse> => {
        const url = `Tasks/get-board-tasks-for-tester/${currentURL}`;
        return handleRequest(url);
    };

    const getTaskVersions = async (type: string): Promise<ApiResponse> => {
        const url = `Tasks/get-task-versions/${type}`;
        return handleRequest(url);
    };

    const getFilteredData = async (
        filters: any,
        id: string
    ): Promise<ApiResponse> => {
        const url = `Tasks/get-filtered-data/${id}`;
        return handleRequest(url, "POST", filters);
    };

    const createTask = async (task: IFrontTask): Promise<ApiResponse> => {
        const url = `Tasks/create-task`;
        return handleRequest(url, "POST", task);
    };

    const updateTaskVersion = async (version: string, id: string): Promise<ApiResponse> => {
        const url = `Tasks/update-task-version/${version}/${id}`;
        return handleRequest(url, "POST");
    };

    const updateTask = async (task: IFrontTask): Promise<ApiResponse> => {
        const url = `Tasks/update-task`;
        return handleRequest(url, "POST", task);
    };

    const getTaskByTrelloId = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/get-task-by-trelloId/${id}`;
        return handleRequest(url);
    };

    const getTaskEvidency = async (id: string): Promise<Blob | null> => {
        // Se o ID contém "Tracker/", usa o endpoint para path
        if (id.includes('Tracker/')) {
            const encodedPath = encodeURIComponent(id);
            const url = `Tasks/get-task-evidency-by-path/${encodedPath}`;
            return await handleRequestFile(url);
        } else {
            // Usa o endpoint tradicional
            const url = `Tasks/get-task-evidency/${id}`;
            return await handleRequestFile(url);
        }
    };

    const deleteTaskByTrelloId = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/delete-task-by-trelloId/${id}`;
        return handleRequest(url);
    };

    const moveTaskToList = async (
        name: string,
        id: string
    ): Promise<ApiResponse> => {
        const url = `Tasks/move-task-to-list/${name}/${id}`;
        return handleRequest(url);
    };

    const moveTaskToNextStatus = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/move-task-to-next-status/${id}`;
        return handleRequest(url, "POST");
    };

    const reproveTask = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/reprove-task/${id}`;
        return handleRequest(url);
    };


    const getTaskComments = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/get-task-comments/${id}`;
        return handleRequest(url);
    };

    const getTaskActions = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/get-task-actions/${id}`;
        return handleRequest(url);
    };

    const addNewComment = async (
        id: string,
        comment: string,
        code: string
    ): Promise<ApiResponse> => {
        const url = `Tasks/add-new-comment/${id}/${code}`;
        return handleRequest(url, "POST", comment);
    };

    const editComment = async (
        id: string,
        commentId: string,
        comment: string
    ): Promise<ApiResponse> => {
        const url = `Tasks/update-comment/${id}/${commentId}`;
        return handleRequest(url, "POST", comment);
    };

    const deleteComment = async (
        id: string,
        commentId: string
    ): Promise<ApiResponse> => {
        const url = `Tasks/remove-comment/${id}/${commentId}`;
        return handleRequest(url);
    };

    const aprovePartnerTask = async (
        id: string,
        priority: string
    ): Promise<ApiResponse> => {
        const url = `Tasks/aprove-partner-task/${id}/${priority}`;
        return handleRequest(url);
    };


    const aprovePartnerCustomization = async (
        id: string,
        priority: string
    ): Promise<ApiResponse> => {
        const url = `Tasks/aprove-partner-task/${id}`;
        return handleRequest(url, "POST", priority);
    };

    const avoidTask = async (
        id: string,
        comment: string
    ): Promise<ApiResponse> => {
        const url = `Tasks/avoid-task/${id}`;
        return handleRequest(url, "POST", comment);
    };

    const newVote = async (newVote: any): Promise<ApiResponse> => {
        const url = `Tasks/new-vote`;
        return handleRequest(url, "POST", newVote);
    };

    const getTaskDevInfo = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/get-task-dev-info/${id}`;
        return handleRequest(url);
    };

    const taskInExternalFactor = async (taskId: string, emailMessage: string): Promise<ApiResponse> => {
        const url = `Tasks/task-in-external-factor/${taskId}`;
        return handleRequest(url, "POST", emailMessage);
    };

    const startTaskDevelopment = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/start-task-development/${id}`;
        return handleRequest(url);
    };

    const stopTaskDevelopment = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/stop-task-development/${id}`;
        return handleRequest(url);
    };

    const joinTheTask = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/join-the-task/${id}`;
        return handleRequest(url);
    };

    const leaveTheTask = async (id: string): Promise<ApiResponse> => {
        const url = `Tasks/leave-the-task/${id}`;
        return handleRequest(url);
    };

    //Tools
    const getAllTools = async (): Promise<ApiResponse> => {
        const url = `Tools/get-tools/`;
        return handleRequest(url);
    };

    const getToolById = async (id: string): Promise<ApiResponse> => {
        const url = `Tools/get-tool-by-id/${id}`;
        return handleRequest(url);
    };

    const createNewTool = async (newTool: any): Promise<ApiResponse> => {
        const url = `Tools/crete-new-tool`;
        return handleRequest(url, "POST", newTool);
    };

    const updateTool = async (newTool: any): Promise<ApiResponse> => {
        const url = `Tools/update-tool`;
        return handleRequest(url, "POST", newTool);
    };

    const deleteTool = async (id: string): Promise<ApiResponse> => {
        const url = `Tools/delete-tool/${id}`;
        return handleRequest(url);
    };

    //Boards
    const getBoards = async (): Promise<ApiResponse> => {
        const url = `Boards/get-boards`;
        return handleRequest(url);
    };

    const getBoardById = async (id: string): Promise<ApiResponse> => {
        const url = `Boards/get-board-by-id/${id}`;
        return handleRequest(url);
    };

    const createNewBoard = async (newBoard: IBoard): Promise<ApiResponse> => {
        const url = `Boards/crete-new-board`;
        return handleRequest(url, "POST", newBoard);
    };

    const updateBoard = async (newBoard: IBoard): Promise<ApiResponse> => {
        const url = `Boards/update-board`;
        return handleRequest(url, "POST", newBoard);
    };

    const deleteBoard = async (id: string): Promise<ApiResponse> => {
        const url = `Boards/delete-board/${id}`;
        return handleRequest(url);
    };

    //#region Pocketnaro
    const updateIdsTaskMembers = async (): Promise<ApiResponse> => {
        const url = `Partner/get-partner-data/arquiris@myia.com.br`;
        return handleRequest(url, "GET");
    };

    const updateMemberToTrelloId = async (): Promise<ApiResponse> => {
        const url = `Pocketnaro/update-member-to-trelloId`;
        return handleRequest(url, "GET");
    };

    const updateListToStatus = async (): Promise<ApiResponse> => {
        const url = `Pocketnaro/update-list-to-status`;
        return handleRequest(url, "GET");
    };

    const updateAllVersions = async (): Promise<ApiResponse> => {
        const url = `Pocketnaro/update-all-versions`;
        return handleRequest(url, "PUT");
    };

    //#endregion

    const testPartnerEmail = async (): Promise<ApiResponse> => {
        const url = `Partner/get-partner-data/suporte@vendaerp.com.br`;
        return handleRequest(url, "GET");
    };

    const getInertiaNotifications = async (): Promise<ApiResponse> => {
        const url = `Global/get-inertia-notifications`;
        return handleRequest(url);
    };



    // #region Status
    const createStatus = async (status: any): Promise<ApiResponse> => {
        const url = `Status/create`;
        return handleRequest(url, "POST", status);
    };

    const updateStatus = async (status: any): Promise<ApiResponse> => {
        const url = `Status/update`;
        return handleRequest(url, "POST", status);
    };

    const detailStatus = async (id: string): Promise<ApiResponse> => {
        const url = `Status/details/${id}`;
        return handleRequest(url, "GET");
    };

    const deleteStatus = async (id: string): Promise<ApiResponse> => {
        const url = `Status/delete/${id}`;
        return handleRequest(url, "DELETE");
    };

    const getAllStatus = async (): Promise<ApiResponse> => {
        const url = `Status/list`;
        return handleRequest(url, "GET");
    };

    // #endregion

    // #region UploadHomologacao
    const uploadHomologacao = async (
        data: IStatusUploadHomologacao
    ): Promise<ApiResponse> => {
        const url = `UploadHomologacao/start-upload-homologacao`;
        return handleRequest(url, "POST", data);
    };

    const getStatusUploadHomologacao = async (
        id: string
    ): Promise<ApiResponse> => {
        const url = `UploadHomologacao/get-status-upload-homologacao/${id}`;
        return handleRequest(url);
    };

    // #endregion

    // #region WhiteLabels

    const getWhiteLabels = async (emails: string[]): Promise<ApiResponse> => {
        const url = `WhiteLabel/get-whitelabels?emails=${emails.join(";")}`;
        return handleRequest(url);
    };
    // #endregion

    //#region Profile

    const getDeadlineTasks = async (): Promise<ApiResponse> => {
        const url = `Profile/get-deadline`;
        return handleRequest(url);
    };

    const getComplexityGraph = async (): Promise<ApiResponse> => {
        const url = `Profile/get-complexity-graph`;
        return handleRequest(url);
    };

    const getToolsGraph = async (): Promise<ApiResponse> => {
        const url = `Profile/get-tools-graph`;
        return handleRequest(url);
    };

    //#endregion

    //#region MemberActions



    const getAllMemberActions = async (): Promise<ApiResponse> => {
        const url = `Register/get-all-member-actions`;
        return handleRequest(url);
    };

    const updateAllMemberActions = async (data: IMemberActions[]): Promise<ApiResponse> => {
        const url = `Register/update-member-actions`;
        return handleRequest(url, "POST", data);
    };

    const calculateMemberActionsChange = async (data: IMemberActions, type: string): Promise<ApiResponse> => {
        const url = `Register/calculate-member-actions-percentage/${type}`;
        return handleRequest(url, "POST", data);
    };

    const getMemberActionByStatus = async (id: string): Promise<ApiResponse> => {
        const url = `Register/get-all-actions/${id}`;
        return handleRequest(url);
    };

    const updateMembersActions = async (data: IMemberActions): Promise<ApiResponse> => {
        const url = `Register/update-member-actions-percentage`;
        return handleRequest(url, "POST", data);
    };

    //#endregion

    //#region code

    const getCode = async (email: string, taskId: string): Promise<ApiResponse> => {
        const url = `Tasks/get-comment-code/${taskId}`;
        return handleRequest(url, "POST", email);
    }

    //#endregion

    //#region Public Tasks (sem autenticação - não usa handleRequest)

    const searchPublicApprovedTasks = async (filters: any): Promise<ApiResponse> => {
        try {
            setLoading(true);
            const response = await fetch('api/PublicTasks/search', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filters),
            });

            if (response.ok) {
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    const data = await response.json();
                    return data;
                } else {
                    console.error('Resposta não é JSON. Status:', response.status, 'URL:', response.url);
                    const text = await response.text();
                    console.error('Conteúdo recebido:', text.substring(0, 200));
                    return { success: false, msg: 'Endpoint retornou HTML em vez de JSON. Verifique se o servidor está rodando e a rota está correta.' };
                }
            } else {
                console.error('Erro HTTP:', response.status, response.statusText);
                const text = await response.text();
                console.error('Resposta de erro:', text.substring(0, 200));
                return { success: false, msg: `Erro ${response.status}: ${response.statusText}` };
            }
        } catch (error) {
            console.error('Erro ao buscar tarefas públicas:', error);
            return { success: false, msg: 'Erro ao processar a solicitação. Verifique o console para mais detalhes.' };
        } finally {
            setLoading(false);
        }
    };

    const getPublicTaskById = async (taskId: string): Promise<ApiResponse> => {
        try {
            setLoading(true);
            const response = await fetch(`api/PublicTasks/${taskId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                const errorData = await response.json();
                return { success: false, msg: errorData.msg || 'Erro ao buscar tarefa' };
            }
        } catch (error) {
            console.error('Erro ao buscar tarefa pública:', error);
            return { success: false, msg: 'Erro ao processar a solicitação' };
        } finally {
            setLoading(false);
        }
    };

    //#endregion

    return {
        loading,
        getDashboardData,
        getDashboardRealGraphData,
        getBoardMembers,
        updateMember,
        signUp,
        signIn,
        getMetricsMembers,
        saveSettings,
        getSettings,
        getAllBoards,
        getDashboardBadges,
        getDashboardLists,
        getApiTokenLink,
        getMenuData,
        getUserRoleInBoard,
        getMemberById,
        getMetrics,
        getReportData,
        getMemberCode,
        authWithCode,
        getBoardTasks,
        getFilters,
        getFilteredData,
        createTask,
        getTaskByTrelloId,
        getTaskEvidency,
        deleteTaskByTrelloId,
        moveTaskToList,
        moveTaskToNextStatus,
        updateTask,
        updateTaskVersion,
        getMembers,
        getTaskComments,
        getTaskActions,
        addNewComment,
        getCurrentUserRole,
        getTaskDevInfo,
        startTaskDevelopment,
        joinTheTask,
        leaveTheTask,
        avoidTask,
        getAllTools,
        deleteTool,
        getToolById,
        updateTool,
        createNewTool,
        newVote,
        stopTaskDevelopment,
        getMyNotifications,
        viewNotification,
        deleteComment,
        editComment,
        getTaskVersions,
        getBoards,
        getBoardById,
        createNewBoard,
        updateBoard,
        deleteBoard,
        createMember,
        updateIdsTaskMembers,
        updateMemberToTrelloId,
        getBoardTasksForTester,
        updateListToStatus,
        createStatus,
        updateStatus,
        detailStatus,
        deleteStatus,
        getAllStatus,
        testPartnerEmail,
        uploadHomologacao,
        getStatusUploadHomologacao,
        currentMemberCanScreeaning,
        getCurrentMember,
        isPageScreening,
        aprovePartnerTask,
        aprovePartnerCustomization,
        getWhiteLabels,
        getInertiaNotifications,
        getDeadlineTasks,
        getComplexityGraph,
        getToolsGraph,
        getAllMemberActions,
        updateAllMemberActions,
        calculateMemberActionsChange,
        clearNotifications,
        getMemberActionByStatus,
        updateMembersActions,
        getScreeningMetrics,
        deleteMembers,
        getCode,
        updateAllVersions,
        taskInExternalFactor,
        searchPublicApprovedTasks,
        getPublicTaskById,
    };
};

export default useApiRequests;
